import { createAction } from 'redux-actions'

import { createRequestActions } from 'store/actionCreators'

export const getCompletedProtracks = createRequestActions('COMPLETED_PROTRACKS/REQUEST', () => ({
  request: {
    url: '/completed-protracks-levels',
  },
}))

export const getCompletedActivities = createRequestActions('COMPLETED_PROTRACKS_ACTIVITIES/REQUEST', id => ({
  request: {
    url: `/completed-protracks-levels/${id}`,
  },
}))

export const setCurrentPage = createAction('COMPLETED_PROTRACKS/SET_CURRENT_PAGE', (current: any) => ({
  current,
}))

export const setView = createAction('COMPLETED_PROTRACKS/SET_VIEW', (id: number) => ({ id }))

export const removeActivityFromFavorites = createRequestActions(
  'COMPLETED_PROTRACKS_ACTIVITIES/REMOVE_FROM_FAVORITES',
  ({ activityId }) => ({
    request: {
      url: `/favorites/activities/${activityId}`,
      method: 'DELETE',
    },
  })
)

export const addActivityToFavorites = createRequestActions(
  'COMPLETED_PROTRACKS_ACTIVITIES/ADD_TO_FAVORITES',
  ({ activityId }) => ({
    request: {
      url: '/favorites/activities/',
      method: 'POST',
      data: { id: activityId },
    },
  })
)
